<section [ngClass]="'fixed'">
  <app-navbar-header (scroll)="onScroll()"></app-navbar-header>
  <app-navbar-links *ngIf="screenWidth > 768"></app-navbar-links>
</section>
<!-- [ngClass]="'fixed'" -->
<!-- [ngClass]="isNavbarFixed?'fixed':'notfixed'"  -->
